//@flow
import { compose, lifecycle } from 'recompose'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { connect } from 'react-redux'

import { Modal } from 'common-components/index'
import type { AppState } from 'quick-quote/reducers'
import { Link } from 'react-router-dom'
import { clearRMSResults } from 'core/actions'
import { IsRealDevice } from 'e-submission/utils'
import { getCurrentApp } from 'e-submission/apps/selectors'

class VideoConsentWarning extends React.Component {
  render() {
    const { isOpen } = this.props
    return (
      <Modal
        className={'video-consent-warning-modal'}
        isOpen={isOpen}
        size="md"
        modalClassName="default-bootstrap remote-selling-modal"
      >
        <ModalHeader className={'header-modal'}>
          บันทึกภาพ
          <Link to={'/'}>
            <Button
              className="close"
              type="button"
              style={{ fontSize: '1.5rem', position: 'absolute', right: '15px', top: '5px' }}
            >
              &times;
            </Button>
          </Link>
        </ModalHeader>
        <ModalBody>
          <div className={'flex-container'} style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', paddingLeft: '30px' }}>
              ขั้นตอนการบันทึกภาพไม่สามารถใช้งานผ่านเว็บ
              <br />
              เบราว์เซอร์ได้ กรุณาล็อกอินผ่านแอปพลิเคชั่นเท่านั้น
              <br />
            </div>
          </div>
          <div className={'normal-text detail-text modal-title'} style={{ color: '#2425aa' }}></div>
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToVideoConsentWarning = (state: AppState, props) => {
  let isOpen = false
  const selectedRemoteSellingFromApp = getCurrentApp(state)
  if (selectedRemoteSellingFromApp.selectedRemoteSelling) {
    isOpen =
      selectedRemoteSellingFromApp.selectedRemoteSelling &&
      !IsRealDevice &&
      selectedRemoteSellingFromApp.status === 'signed'
  }

  return {
    isOpen,
  }
}

const mapDispatchToVideoConsentWarning = (dispatch: Dispatch<*>, props) => ({})

export default compose(connect(mapStateToVideoConsentWarning, mapDispatchToVideoConsentWarning))(VideoConsentWarning)
